import { useState } from 'react';
import dummyPhoto from '../../../Assets/Image/thumbnail.jpg';
import Modal from './Modal';

export default function ProductCards({logo, name, description, modalUrl}) {

    const [showModal, setShowModal] = useState(false);

    const openModal = () => {
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    return (
        <div className="m-4 flex flex-col h-[512px] w-[382px] bg-white rounded-3xl shadow-lg relative">
            <div
                style={{
                    backgroundColor: "#e8e8e8",
                }}
                className="relative top-0 left-0 flex items-center justify-center h-2/5 bg-cover bg-center rounded-t-3xl rounded-e-3xl px-4"
            >
                {logo ? 
                <img src={`${logo}`} alt="logo" className="aspect-auto w-2/3" draggable="false" />:
                <img src={`${dummyPhoto}`} alt="dummy" className="aspect-auto h-4/5" draggable="false"/>
                }
            </div>
            <div className='flex flex-col px-5 py-3 flex-grow'>
                <h1 className='text-3xl font-bold mb-3'>{name ? name : "Product"}</h1>
                <p className='text-xl max-h-[168px] overflow-hidden overflow-ellipsis'>{description ? description : "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Quisquam voluptas reprehenderit delectus adipisci officia vitae. Fuga nulla quia incidunt laboriosam est vero laborum voluptatem, temporibus reprehenderit architecto maxime, laudantium enim."}</p>
            </div>
            <button className='absolute bottom-6 right-6 text-blue-500' onClick={openModal}>More Details...</button>
            {showModal && (
                <Modal onClose={closeModal} imageUrl={modalUrl}/>
            )}
        </div>
    );
}
